import { render, staticRenderFns } from "./edl.vue?vue&type=template&id=c033c65c"
import script from "./edl.vue?vue&type=script&lang=js"
export * from "./edl.vue?vue&type=script&lang=js"
import style0 from "./edl.vue?vue&type=style&index=0&id=c033c65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports